module.exports = __webpack_public_path__ + "static/favicons/mstile-150x150-4f6267c026a63f157315d62849649ac6.png";